import bookingService from 'components/Booking-new/services/BookingService';

export default async function (locationCode, serviceCode, maxDaysToShow, isRescheduling) {
  const { data, error } = await bookingService.getLocationTimeSlots(locationCode, serviceCode);

  if (error !== null)
    // TODO: uncomment when sessionstorage provider is added
    // sessionStorage.removeItem('booking')
    return { error };

  let slots = Object.entries(data.slots).sort((a, b) => a[0].localeCompare(b[0])); // The order of the array returned by Object.entries() does not depend on how an object is defined. That is why we have to sort it.

  const noDatesAvailable = !slots.some(([, times]) => times.length); // this info is needed to display error message with "waitlist link"
  if (noDatesAvailable)
    return {
      error: {
        noDatesAvailable: true,
      },
    };

  const firstAvailableTime = slots.findIndex(([, times]) => times.length); // cut the array of dates until the date with available time slots
  if (firstAvailableTime > 0) slots = slots.splice(firstAvailableTime);

  // Take in consideration only available slots to limit how many is shown and if isn't rescheduling
  if (maxDaysToShow && !isRescheduling) slots = slots.filter(slot => slot[1].length).slice(0, maxDaysToShow);

  // transform list of key-value into an object
  // from:
  /* [
		['2021-09-16', ['19:00:00.000Z', '19:30:00.000Z']],
		['2021-09-17', ['17:00:00.000Z', '19:00:00.000Z', '19:30:00.000Z']],
		['2021-09-18', []],
	   ]
	*/
  // to:
  /* {
		'2021-09-16': ['19:00:00.000Z', '19:30:00.000Z'],
		'2021-09-17': ['17:00:00.000Z', '19:00:00.000Z', '19:30:00.000Z'],
		'2021-09-18': []
		}
	*/
  const slotsObject = Object.fromEntries(slots);

  // const eventBody = {
  // 	location: booking.bookedResults.location.code,
  // 	type: booking?.type,
  // }

  return { data: { ...data, slots: slotsObject } };
}
